var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppTwilio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    style: {
      fill: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.36 0C49.94 0 .35 49.82.25 111.35L0 265.27c-.1 58.82 45.49 106.39 103.11 110.57V472c0 4.42 3.58 8 8 8 2.13 0 4.16-.84 5.67-2.35l100.76-101.01h151.35c61.43 0 111.11-49.82 111.11-111.36V111.36C480 49.84 430.57 0 369.14 0H111.36zm0 15.99h257.78c52.82 0 94.86 42.36 94.86 95.37v153.91c0 52.98-42.29 95.37-95.11 95.37H214.22c-2.13 0-4.17.85-5.67 2.36l-89.45 89.66v-84.01c0-4.41-3.58-7.99-7.99-7.99-52.82 0-95.2-42.39-95.12-95.35l.25-153.92c.08-53 42.3-95.37 95.12-95.37zM160 164.32c-13.16 0-24 10.84-24 24s10.84 24 24 24 24-10.84 24-24-10.84-24-24-24zm80 0c-13.16 0-24 10.84-24 24s10.84 24 24 24 24-10.84 24-24-10.84-24-24-24zm80 0c-13.16 0-24.01 10.84-24.01 24s10.85 24 24.01 24 24-10.84 24-24-10.84-24-24-24zm-160 16c4.51 0 8 3.48 8 7.99s-3.49 8-8 8-8-3.49-8-8 3.49-7.99 8-7.99zm80 0c4.51 0 7.99 3.48 7.99 7.99s-3.48 8-7.99 8-8-3.49-8-8 3.49-7.99 8-7.99zm80 0c4.51 0 7.99 3.48 7.99 7.99s-3.48 8-7.99 8-8-3.49-8-8 3.49-7.99 8-7.99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppTwilio);
export default __webpack_public_path__ + "static/media/app-twilio.44f51ee44b0a088abb4d453a23d2ded9.svg";
export { ForwardRef as ReactComponent };